import React, { useContext } from 'react';
import Steps from '../Steps';
import '../../stylesheets/stylesLayout/service-desk.scss';
import ContactStepsContainer from './ContactStepsContainer';
import ContactInformation from './ContactInformation';
import { ContextContact } from '../../contexts/ContactContext';

const Contact = () => {
    const { stepsCount, step, setStep } = useContext(ContextContact);
    return (
        <div className='service-desk__container'>
            <div className='steps__section'>
                <Steps
                    stepsCount={stepsCount}
                    step={step}
                    setStep={setStep}
                    disabledSteps={step === stepsCount}
                />
            </div>
            <div className='service-desk__content'>
                <ContactInformation />
                <ContactStepsContainer />
            </div>
        </div>
    );
};

export default Contact;
